import { render, staticRenderFns } from "./UserLoginHandler.vue?vue&type=template&id=80787ad2"
import script from "./UserLoginHandler.vue?vue&type=script&lang=js"
export * from "./UserLoginHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports